"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PUBLIC_ID_TOKEN = exports.PUBLIC_ID_MAX_LENGTH = void 0;
exports.luhnCheckDigit = luhnCheckDigit;
exports.isLuhnPublicId = isLuhnPublicId;
exports.formatPublicId = formatPublicId;
/**
 * Public user ID: generated ids are nine Luhn-checked digits; imported ids (spec 2026-09-25)
 * are free tokens, so only the formatter and admin search care about the Luhn shape.
 */
const PUBLIC_ID = /^[1-9]\d{8}$/;
const NINE_DIGITS = /^\d{9}$/;
exports.PUBLIC_ID_MAX_LENGTH = 32;
exports.PUBLIC_ID_TOKEN = /^\S+$/;
/** Standard Luhn (ISO/IEC 7812-1) check digit for `digits`, as if appended on the right. */
function luhnCheckDigit(digits) {
    let sum = 0;
    let double = true;
    for (let i = digits.length - 1; i >= 0; i--) {
        let n = Number(digits[i]);
        if (double) {
            n *= 2;
            if (n > 9)
                n -= 9;
        }
        sum += n;
        double = !double;
    }
    return String((10 - (sum % 10)) % 10);
}
function isLuhnPublicId(value) {
    if (!PUBLIC_ID.test(value))
        return false;
    return luhnCheckDigit(value.slice(0, 8)) === value[8];
}
/** `'482190378'` → `'482 190 378'`; anything that is not nine digits comes back unchanged. */
function formatPublicId(value) {
    if (!NINE_DIGITS.test(value))
        return value;
    return `${value.slice(0, 3)} ${value.slice(3, 6)} ${value.slice(6)}`;
}
//# sourceMappingURL=public-id.js.map